
import React from 'react';
import { Class, Enrollment } from "@/types/classTypes";
import AttendanceTracker from "@/components/attendance/AttendanceTracker";
import AttendanceAlerts from "@/components/attendance/AttendanceAlerts";

interface AttendanceTabProps {
  classData: Class;
  organizationId: string;
  enrollments: Enrollment[];
  attendanceRecords: any[];
  isLoadingAttendance: boolean;
  onSendReminder: (studentIds: string[]) => Promise<void>;
}

const AttendanceTab: React.FC<AttendanceTabProps> = ({
  classData,
  organizationId,
  enrollments,
  attendanceRecords,
  isLoadingAttendance,
  onSendReminder
}) => {
  return (
    <div className="pt-4">
      {!isLoadingAttendance && attendanceRecords.length > 0 && (
        <AttendanceAlerts 
          classData={classData}
          attendanceRecords={attendanceRecords}
          onSendReminder={onSendReminder}
        />
      )}
      
      <AttendanceTracker 
        classId={classData.id} 
        enrollments={enrollments.filter(e => e.status === 'active')}
        organizationId={organizationId}
      />
    </div>
  );
};

export default AttendanceTab;
